package com.appsyde.shared.presentation.screen.screen

import androidx.compose.runtime.Composable
import com.appsyde.shared.app.presentation.SessionViewModel
import org.koin.core.context.GlobalContext
import com.appsyde.shared.presentation.style.animations.AppStylesAnimations
import com.appsyde.shared.presentation.style.style.AppStylesAccount
import com.appsyde.shared.presentation.style.style.AppStylesGlobal
import com.appsyde.shared.presentation.style.style.AppStylesHeader
import com.appsyde.shared.presentation.style.style.AppStylesLayout
import com.appsyde.shared.presentation.style.style.AppStylesWizard
import kotlinx.browser.window
import org.jetbrains.compose.web.dom.*
import org.jetbrains.compose.web.css.Style
import org.jetbrains.compose.web.css.*

private object NoWorkspaceStyles : org.jetbrains.compose.web.css.StyleSheet() {
    val noWorkspaceList by style {
        marginTop(12.px)
        marginBottom(20.px)
        paddingLeft(20.px)
        property("list-style-type", "disc")
        fontSize(15.px)
        fontWeight(400)
        color(org.jetbrains.compose.web.css.Color("#6B7280"))
        lineHeight("1.65")
    }
    val noWorkspaceSubtext by style {
        marginTop(8.px)
        fontSize(13.px)
        fontWeight(400)
        color(org.jetbrains.compose.web.css.Color("#9CA3AF"))
    }
    val noWorkspaceCtaWrap by style {
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Column)
        alignItems(AlignItems.FlexStart)
        marginTop(8.px)
    }
}

/**
 * Écran : connecter une boîte Gmail support pour créer son premier workspace.
 * Même structure visuelle que la page d'acceptation d'invitation.
 * Le CTA lance le flow de création de compte (signup) + connexion Gmail.
 */
@Composable
fun NoWorkspaceScreen() {
    Style(AppStylesAnimations)
    Style(AppStylesGlobal)
    Style(AppStylesHeader)
    Style(AppStylesLayout)
    Style(AppStylesWizard)
    Style(AppStylesAccount)
    Style(NoWorkspaceStyles)

    val sessionViewModel = GlobalContext.get().get<SessionViewModel>()
    val origin = window.location.origin

    Div(attrs = { classes(AppStylesGlobal.appRoot) }) {
        // Même header que la page invitation : 46px, pas de météo, pas de label au centre
        Div(attrs = { classes(AppStylesHeader.header) }) {
            Div(attrs = { classes(AppStylesAccount.invitePageHeaderInner) }) {
                Div(attrs = { classes(AppStylesHeader.brandRow) }) {
                    Img("/appsydeIcon.png", attrs = {
                        classes(AppStylesHeader.brandIcon)
                        attr("alt", "AppSyde")
                    })
                    Div(attrs = { classes(AppStylesHeader.brandCol) }) {
                        Div(attrs = { classes(AppStylesHeader.brand) }) { Text("AppSyde") }
                        Span(attrs = { classes(AppStylesHeader.brandSubtitle) }) { Text("Workspace") }
                    }
                }
                Span(attrs = { classes(AppStylesAccount.invitePageHeaderRight) }) { Text("Connecter une boîte") }
            }
        }

        Div(attrs = { classes(AppStylesGlobal.global, AppStylesLayout.globalContentWrap, AppStylesLayout.wizardPageWrap) }) {
            Div(attrs = { classes(AppStylesLayout.wizardContentWrapCentered) }) {
                Div(attrs = { classes(AppStylesAccount.inviteCardWrap) }) {
                    Div(attrs = { classes(AppStylesAccount.inviteCard) }) {
                        Div(attrs = { classes(AppStylesAccount.inviteCardInner, AppStylesAnimations.pageReveal) }) {
                            Div(attrs = { classes(AppStylesAccount.inviteHeroIconWrap) }) {
                                Span(attrs = { classes(AppStylesAccount.inviteHeroIcon) }) { Text("📭") }
                            }
                            Div(attrs = { classes(AppStylesAccount.inviteTitle) }) {
                                Text("Connectez votre boîte Gmail support")
                            }
                            Div(attrs = { classes(AppStylesAccount.inviteDescription) }) {
                                Text("Pour commencer à utiliser AppSyde, vous devez connecter une boîte Gmail utilisée pour votre support client (ex : support@, contact@).")
                            }
                            Div(attrs = { classes(AppStylesAccount.inviteDescription) }) {
                                Text("AppSyde pourra :")
                            }
                            Ul(attrs = { classes(NoWorkspaceStyles.noWorkspaceList) }) {
                                Li { Text("lire les emails entrants") }
                                Li { Text("afficher les conversations") }
                                Li { Text("vous aider à rédiger et envoyer des réponses") }
                            }
                            Div(attrs = { classes(AppStylesAccount.inviteDescription) }) {
                                Text("Vous gardez le contrôle : aucune modification n'est faite dans Gmail sans votre action.")
                            }
                            Div(attrs = { classes(NoWorkspaceStyles.noWorkspaceCtaWrap) }) {
                                Button(attrs = {
                                    classes(AppStylesAccount.inviteBtnPrimary)
                                    attr("type", "button")
                                    onClick {
                                        sessionViewModel.startSignup(origin)
                                    }
                                }) { Text("Connecter une boîte Gmail") }
                                Span(attrs = { classes(NoWorkspaceStyles.noWorkspaceSubtext) }) {
                                    Text("Cela crée votre premier workspace AppSyde.")
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}
